<template>
    <a-spin :spinning="busy" :delay="200" class="tab-general" style="width: 100%">
        <vx-card @click="openBill" class="grid-view-item">
            <div class="flex">
                <div style="flex: 1" >
                    <b v-if="invoice.disposedAt">{{ invoice.disposedAt.toDate() | dateFormat('DD/MM/YYYY HH:mm:ss') }}</b>
                    <b v-else>{{ date | dateFormat('DD/MM/YYYY HH:mm:ss') }}</b>
                    <h5 class="text-primary font-semibold mb-0 mt-2">{{ totalValue | currency }}</h5>
                    
                    <vs-divider border-style="dashed" class="pr-4" v-if="invoice.pending || invoice.disposed || invoice.sentAt"/>
                  
                    <div class="mt-3" v-if="invoice.pending">
                        <h6>{{ invoice.attempt + 1 }} tentativa(s)</h6>
                        <h6 v-if="invoice.attempt < 3">Prox. tentativa : {{ nextAttempt.fromNow() }}</h6>
                        <h6 v-else>Tentativas encerradas</h6>
                        <b>Razão de contingência:</b><br/>
                        - <v-clamp :max-lines="1">
                            {{ reason }}
                            <a-tooltip slot="after" slot-scope="{ clamped }" v-if="clamped" :title="reason">
                                <vs-icon icon="info" color="primary" size="16px"></vs-icon>
                            </a-tooltip>
                        </v-clamp>
                        <vs-divider border-style="dashed" class="pr-4" v-if="invoice.pending || invoice.disposed || invoice.sentAt"/>
                    </div>
                    <div class="mt-3" v-if="invoice.disposed">
                        <h6 v-if="invoice.disposedAt">Enviada em: {{ date | dateFormat('DD/MM/YYYY HH:mm:ss') }}</h6>
                        Protocolo:
                        <b>{{ invoice.protocol || 'Sem protocolo registrado' }}</b><br/>
                        <v-clamp class="mt-2 text-danger" :max-lines="1">
                            {{ invoice.reason || 'Sem motivo registrado' }}
                            <a-tooltip slot="after" slot-scope="{ clamped }" v-if="clamped" :title="reason">
                                <vs-icon icon="info" color="primary" size="16px"></vs-icon>
                            </a-tooltip>
                        </v-clamp>
                    </div>
                      
                    <div class="mt-3">
                        <h5>nº {{invoice.docFiscal.numeroNota}}</h5>
                        <v-clamp class="mt-2 text-danger" :max-lines="1">
                            {{ invoice.key || invoice.docFiscal.serie }}<b> </b><br/>
                            <a-tooltip slot="after" slot-scope="{ clamped }" v-if="clamped" title="Clique para copiar">
                                <vs-icon icon="info" color="primary" size="16px"
                                    @click.stop="clickToCopy"></vs-icon>
                            </a-tooltip>
                        </v-clamp>
                    </div>

                </div>
                
                <div class="flex-column mt-2">
                    <a-tooltip title="Imprimir" class="mb-2">
                        <vs-button @click.stop="printDocument"
                            :disabled="busy"
                            type="border" icon="print"></vs-button>
                    </a-tooltip>
                    <a-tooltip title="Abrir arquivo da nota">
                        <vs-button @click.stop="openXml"
                            :disabled="busy || !invoice.xmlPath.sentUrl"
                            type="border" icon="receipt"></vs-button>
                    </a-tooltip>
                    <a-tooltip title="Editar" v-if="invoice.disposedAt || invoice.pending" class="my-2">
                        <vs-button @click.stop="edit"
                            :disabled="busy"
                            type="border" icon="edit"></vs-button>
                    </a-tooltip>
                    <span v-if="invoice.pending" class="mt-2">
                        <a-tooltip title="Inutilizar">
                            <vs-button @click.stop="dispose"
                                :disabled="busy || !invoice.xmlPath.sentUrl"
                                type="border" icon="block"></vs-button>
                        </a-tooltip>
                        
                        <a-tooltip title="Enviar para Sefaz agora" class="mt-2">
                            <vs-button @click="sendAgain"
                                :disabled="busy || !invoice.xmlPath.sentUrl"
                                type="border" icon="send"></vs-button>
                        </a-tooltip>
                    </span>
                </div>
            </div>
        </vx-card>

        <modal-edit-fiscal-data
            v-if="editModal.show"
            v-model="editModal.show"
            :invoice="invoice">

        </modal-edit-fiscal-data>

        <modal-users-orders
            viewOnly
            :visible="modalBill.visible"
            :table="modalBill.table"
            @close="(value) => modalBill.visible = value"
        />
    </a-spin>
</template>

<script>
    import VClamp from 'vue-clamp'
    import firebase from '@/firebase/firebase'
    import * as moment from 'moment'
    import { mapGetters, mapMutations } from 'vuex';
    import { httpsCallable } from "@/firebase/functions";
    import ModalUsersOrders from '@/components/bill/ModalUsersOrders'
    import ModalEditFiscalData from './ModalEditFiscalData';

    export default {
        components: {
            VClamp,
            ModalUsersOrders,
            ModalEditFiscalData
        },
        props: {
            invoice: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                busy: false,
                now: new Date(),
                modalBill: {
                    visible: false,
                    table: null
                },
                editModal: {
                    show: false
                }
            }
        },
        computed: {
            date () {
                return new Date(this.invoice.pending ? this.invoice.docFiscal.dhContingencia : this.invoice.docFiscal.dhEmissao);
            },
            totalValue () {
                return this.invoice.pagamento.pagamentos.reduce((prev, curr) => prev + parseFloat(curr.valor), 0);
            },
            reason () {
                try {
                    return this.invoice.docFiscal.justificativaContingencia;
                } catch (err) {
                    return 'Desconhecido';
                }
            },
            nextAttempt () {
                const next = moment(this.now).add(2, 'hours').get('hours');
                const adjusment = next % 2 == 0 ? next - 1 : next;
                return moment().locale('pt-BR').set('hours', adjusment).set('minutes', 0).set('seconds', 0);
            },
            ...mapGetters(['getCompanyID'])
        },
        methods: {
            async openBill () {
                if (this.busy)
                    return;
                this.busy = true;
                try {
                    const { getCompanyID, invoice, modalBill } = this;
                    if (!modalBill.table) {
                        const table = await firebase.firestore().collection(`/company/${getCompanyID}/bill/`)
                            .doc(invoice.billId).get()
                        this.$set(this.modalBill, 'table', table.data());
                    }
                    this.modalBill.visible = true;
                } catch (err) {
                    this.$error({
                        zIndex : 999999,
                        title: 'Erro ao carregar conta'
                    });
                }
                this.busy = false;
            },
            openXml () {
                window.open(this.invoice.xmlPath.sentUrl);
            },
            async printDocument () {
                try {
                    this.busy = true;
                    const { getCompanyID } = this;
                    const ref = db.collection(`company/${getCompanyID}/invoice`).doc(this.invoice.id);
                    await ref.update({
                        printAgain: new Date(),
                        print: true
                    });
                } catch (err) {
                    this.setError({ error: err });
                } finally {
                    this.busy = false;
                }
            },
            dispose () {
                this.$emit('dispose', this.invoice);
            },
            edit () {
                this.editModal.show = true;
            },
            async sendAgain () {
                try {
                    this.busy = true;
                    const { getCompanyID, invoice } = this;
                    let remmitBackup = httpsCallable('remmitBackup');
                    const result = await remmitBackup({ companyId : getCompanyID, invoiceId: invoice.id });
                    if (result && result.data.error) {
                        this.$warning({
                            zIndex: 99999,
                            title: 'Reenvio',
                            content: result.data.error || 'Desconhecido'
                        })
                    } else if (result.data.success) {
                        this.$success({
                            zIndex : 9999999,
                            title: 'Sucesso',
                            content: 'Enviado com sucesso'
                        })
                    }
                } catch (err) {
                    this.setError({ error: err, title: 'Erro ao reenviar nota' });
                } finally {
                    this.busy = false;
                }
            },
            clickToCopy () {
                const el = document.createElement('textarea');
                el.value = this.invoice.key;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
                this.$vs.notify({
                    title:'Chave copiada',
                    text:'Valor copiado para área de transferência',
                    color:'primary'
                })
            },
            ...mapMutations(['setError'])
        },
    }
</script>

<style lang="scss" scoped>
.grid-view-item {
    cursor: pointer;
    .grid-view-img {
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.8;
        }
    }
}
</style>